




























































import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Table from '@/components/Table/Index.vue';
import ActivityBody from '@/components/Table/ActiveBody.vue';
import ActivityData from '@/data/ActivityData';
import { IFetchActivity, IActivityLog } from '@/interface/Activity';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ActivityModule from '@/store/modules/Activity';

@Component({
  components: {
    ActivityBody,
    Table,
  },
})
export default class ActivityLogLogin extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  TableHeadActivity = ActivityData.TableHead;

  ActivityInstance = getModule(ActivityModule, this.$store);

  activityTypeList = [
    'ALL',
    'LOGIN',
    'REFRESH TOKEN',
  ];

  userData: Array<IActivityLog> = [
    {
      device: '',
      ipAddress: '',
      timestamp: '',
      role: '',
      username: '',
      type: '',
    },
  ]

  search: IFetchActivity = {
    username : '',
    type: 'ALL',
  };

  handelType(type: string) {
    this.search.type = type;
  }

  async fetchActivityLog(item: any) {
    this.GeneralInstance.toggleLoading(true);
    const params: IFetchActivity = {
      username: item.username,
      type: item.type === 'REFRESH TOKEN' ? 'REFRESH_TOKEN' : item.type,
    };
    const { data , status } = await this.ActivityInstance.FetchActivityLog(params);
    if (status.code === 0) {
      this.userData = data.sort((a: any, b: any) => b.timestamp - a.timestamp);
    }
    if (status.code) this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }
}
